import { render, staticRenderFns } from "./WorkerBlankslatePage.vue?vue&type=template&id=8b6575e6&scoped=true&"
import script from "./WorkerBlankslatePage.vue?vue&type=script&lang=js&"
export * from "./WorkerBlankslatePage.vue?vue&type=script&lang=js&"
import style0 from "./WorkerBlankslatePage.vue?vue&type=style&index=0&id=8b6575e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6575e6",
  null
  
)

export default component.exports